export default __webpack_public_path__ + "static/media/marker.ddb00369.svg";